import { Model } from 'pinia-orm'

import { Attr, BelongsTo, Num, Uid } from 'pinia-orm/dist/decorators'
import { Client } from 'modules/Client/Client'
import { Site } from 'modules/Site/Site'
import { Equipment } from 'modules/Equipment/Equipment'
import { Compartment } from 'modules/Compartment/Compartment'
import { Tank } from 'modules/Tank/Tank'
import { QrHeader } from 'modules/QrHeader/QrHeader'
import { Tenant } from 'modules/Tenant/Tenant'
import { Org } from 'modules/Org/Org'

export class QrCode extends Model {
  static override entity = 'qr_codes'

  @Uid() declare id: string
  @Num(null) declare int_id: number | null

  @Attr(null) declare number_id: number
  @Attr(null) declare label_id: number | null
  @Attr(null) declare code: string | null
  @Attr(null) declare nfc_id: string | null
  @Attr(null) declare file_name: string | null
  @Attr(null) declare pack: string | null
  @Attr(null) declare attached_datetime: string | null
  @Attr(null) declare added_to_entity_datetime: string | null
  @Attr(null) declare brand: string | null
  @Attr(null) declare client_id: string | null
  @Attr(null) declare site_id: string | null
  @Attr(null) declare equipment_id: string | null
  @Attr(null) declare compartment_id: string | null
  @Attr(null) declare tank_id: string | null
  @Attr(null) declare allocated: boolean | null
  @Attr(null) declare file: string | null
  @Attr(null) declare qr_header_id: string | null
  @Attr(null) declare source_id: string | null
  @Attr(null) declare active: boolean | null
  @Attr(null) declare deleted_by_user: string | null
  @Attr(null) declare assigned_type: string | null

  @BelongsTo(() => Client, 'client_id') declare client: Client | null
  @BelongsTo(() => Site, 'site_id') declare site: Site | null
  @BelongsTo(() => Equipment, 'equipment_id') declare equipment: Equipment | null
  @BelongsTo(() => Compartment, 'compartment_id') declare compartment: Compartment | null
  @BelongsTo(() => Tank, 'tank_id') declare tank: Tank | null
  @BelongsTo(() => QrHeader, 'qr_header_id') declare qrHeader: QrHeader | null

  @Attr(null) declare tenant_id: string
  @Attr(null) declare org_id: number
  @BelongsTo(() => Tenant, 'tenant_id') declare tenant: Tenant | null
  @BelongsTo(() => Org, 'org_id') declare org: Org | null
}
